import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const CountrySelection = ({
  countriesDropdown,
  setCountriesDropdown,
  handleMenuClose,
  selectedCountry,
  setSelectedCountry,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuItemClicked = (country) => {
    handleMenuClose(setCountriesDropdown);
    setCountriesDropdown(false);
    setSelectedCountry(country);

    const consent = Cookies.get("cookie-consent");
    if (consent) {
      Cookies.set("countrySelected", country, { expires: 30, path: "/" });
    }

    if (selectedCountry !== country) {
      if (location.pathname === "/") {
      } else {
        navigate("/");
      }
    }
  };

  const countryList = [
    {
      str: "USA",
      printable: "USA",
    },
    {
      str: "Canada",
      printable: "Canada",
    },
    // ,
    // {
    //   str: "India",
    //   printable: "India",
    // },
  ];

  return (
    <Menu
      anchorEl={countriesDropdown}
      open={Boolean(countriesDropdown)}
      onClose={handleMenuClose(setCountriesDropdown)}
    >
      {countryList.map((country) => (
        <MenuItem
          key={country.str}
          onClick={() => handleMenuItemClicked(`${country.str}`)}
        >
          {country.printable}
        </MenuItem>
      ))}
    </Menu>
  );
};

const styles = {
  container: {
    display: "flex",
  },
  buttonText: {
    color: "#fff",
  },
  dropdownOptions: {
    width: 150,
    position: "absolute",
    top: 40,
    backgroundColor: "#fff",
    borderRadius: 5,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
};

export default CountrySelection;
